import { useSuspenseQuery } from '@tanstack/react-query';
import { userQueries } from '@/features/auth/queries';

export function useCountries() {
  return useSuspenseQuery(userQueries.countries()).data;
}
